import { MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import PropTypes from "prop-types";
import { memo } from "react";

function DatePicker(props) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MobileDatePicker
        placeHolder={props.placeHolder}
        openTo="day"
        onChange={props.onChange}
        slotProps={{
          textField: {
            ...props,
            sx: {
              "& .MuiFormHelperText-root": {
                fontSize: "0.9rem",
                marginLeft: 0,
              },
            },
          },
        }}
      />
    </LocalizationProvider>
  );
}

DatePicker.propTypes = {
  props: PropTypes.object,
  onChange: PropTypes.func,
  placeHolder: PropTypes.string,
};
export default memo(DatePicker);
